
import { useState } from "react";
import  "./flavourIntensity.css";


const FlavourIntensity = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.flavourintensity===0?0:data.flavourintensity);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="flavourradiocard" name ="flavourintensity" onChange={onChangeValue}>
    <div class="flavourrating-container">
      
      <div class="flavourrating">
        <form class="flavourrating-form-1" >

          <label for={`FAI1F-${count}`}>
        <input type="radio"  name="flavourintensity" class="flavour1" id={`FAI1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>

          <label for={`FAI2F-${count}`}>
        <input type="radio" name="flavourintensity" class="flavour2" id={`FAI2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>

          <label for={`FAI3F-${count}`}>
        <input type="radio" name="flavourintensity" class="flavour3" id={`FAI3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>

          <label for={`FAI4F-${count}`}>
        <input type="radio" name="flavourintensity" class="flavour4" id={`FAI4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>

        </label>

          <label for={`FAI5F-${count}`}>
        <input type="radio" name="flavourintensity" class="flavour5" id={`FAI5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>


    );
}

export default FlavourIntensity;